<div class="wrapper" (click)="onClickOutside($event)">
  <header>
    <app-usernav
      class="fixed"
      [showMenu]="showMenu"
      (onShowMenu)="onShowMenu($event)"
      (onMenuTemplateRender)="onMneuTempateRender($event)"
    ></app-usernav>
  </header>
  <section id="scrollable">
    <router-outlet></router-outlet>
    <div class="menu-wrapper" [class.active]="showMenu">
      <div class="menu" #menuRef>
        <ng-container [ngTemplateOutlet]="template"></ng-container>
      </div>
    </div>
  </section>
</div>
